export default __webpack_public_path__ + "static/media/drumroll.40508bff.mp3";